import React from 'react';
import { Card, Col, Image, Row, Form, Badge } from 'react-bootstrap';

class CartItemReadOnly extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            Id: 0,
            Name: '',
            Price: '',
            Image: 'kursas1.jpg',
            Quantity: 1,
        };
    }

    componentDidMount() {
        this.setState({ Id: this.props.Id });
        this.setState({ Name: this.props.Name });
        this.setState({ Price: this.props.Price });
        if (this.props.Image) this.setState({ Image: this.props.Image });
        if (this.props.Quantity) this.setState({ Quantity: this.props.Quantity });
    }

    render() {

        const cardImgStyle = {
            borderRadius: '10px',
            height: '70px',
        }

        return (

            <Card className='cart-item-card'>
                <Card.Body>
                    <Row>
                        <Col className='md-1'>
                            <Image src={this.state.Image} style={cardImgStyle} />
                            <Badge pill bg="dark">{this.state.Quantity}</Badge>
                        </Col>
                        <Col className='md-2'>
                            <span>{this.state.Name}</span>
                        </Col>
                        <Col className='md-2'>
                            <span>{this.state.Price * this.state.Quantity} €</span>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }
}

export default CartItemReadOnly;
